import React from 'react';
import PageLayout from '../components/Layout/PageLayout';
import SensorDeviceSetting from '../components/System/SensorDeviceSetting';

/**
 * 센서 정보 수정 페이지 컴포넌트
 *
 * @param {Object} props - 컴포넌트 속성
 * @returns {JSX.Element}
 */
const SensorDeviceManagementPage = (props) => {
    const tabId = props.tabId || 'system-sensor-setting';

    return (
        <PageLayout>
            <SensorDeviceSetting tabId={tabId} />
        </PageLayout>
    );
};

export default SensorDeviceManagementPage;